"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdventureState = void 0;
class AdventureState {
    constructor(id, __typeName, args, adventureId, ownerId) {
        this.id = id;
        this.__typeName = __typeName;
        this.args = args;
        this.adventureId = adventureId;
        this.ownerId = ownerId;
        this.meta = {};
        this.state = "Pending";
    }
}
exports.AdventureState = AdventureState;
